import { action } from "satcheljs";
/**
 * This action is to be dispatched after search is exited and we need
 * to re-select the previous node the user was on before entering into
 * their search session.
 */
export interface SELECT_PREVIOUS_NODEActionMessage {
    actionSource: string;
}
export const selectPreviousNode: (actionSource: string) => SELECT_PREVIOUS_NODEActionMessage = action("SELECT_PREVIOUS_NODE", (actionSource: string): SELECT_PREVIOUS_NODEActionMessage => ({
    actionSource,
}));
